/**
 * Created by Kristy on 22/6/2016.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('adminSchedules', {
                parent: 'app',
                url: '/schedules',
                data: {
                    authorities: ['ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_HEALTH_VISITOR', 'ROLE_REC_MANAGEMENT', 'ROLE_REC_HEALTH_VISITOR', 'ROLE_PHARM_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminSchedules/adminSchedules.html',
                        controller: 'AdminSchedulesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    customersView: ['ApplicationParameters', function (ApplicationParameters) {
                        return ApplicationParameters.customersView();
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
